export default (props) => (
  <svg {...props} viewBox="0 0 30 30" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <path
        d="M8.5 7.375v-1.5l.007-.144a1.5 1.5 0 012.993.144v1.5h-3zM18.5 7.375v-1.5l.007-.144a1.5 1.5 0 012.993.144v1.5h-3z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M6.5 6.875h17a1.5 1.5 0 011.5 1.5v2.375a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5V8.375a1.5 1.5 0 011.5-1.5zM24.5 12.5a.5.5 0 01.5.5v11.75a1.5 1.5 0 01-1.5 1.5h-17a1.5 1.5 0 01-1.5-1.5V13a.5.5 0 01.5-.5h19zm-8.125 8.125h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5zm6.25 0h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5zm-12.5 0h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5zm6.25-6.25h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5zm6.25 0h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5zm-12.5 0h-2.75a.5.5 0 00-.5.5v2.75a.5.5 0 00.5.5h2.75a.5.5 0 00.5-.5v-2.75a.5.5 0 00-.5-.5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
